export default __webpack_public_path__ + "static/media/r.71e45973.svg";